import { HoverCardContent, HoverCardRoot, HoverCardTrigger } from "reka-ui";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";

const Root = HoverCardRoot;

const Trigger = HoverCardTrigger;

const Content = defineComponent({
  name: "HoverCardContent",
  props: {
    side: p.string<"top" | "bottom" | "left" | "right">("top"),
    align: p.string<"start" | "center" | "end">("center"),
    sideOffset: p.number(6),
    avoidCollisions: p.boolean(true),
    collisionBoundary: p.custom<Element | (Element | null)[] | null>([Object, Array]),
    collisionPadding: p.number(4),
  },
  setup(props, { slots, attrs }) {
    return () => (
      <HoverCardContent
        {...props}
        class={cn(
          "data-[side=bottom]:animate-slideUpAndFade data-[side=right]:animate-slideLeftAndFade data-[side=left]:animate-slideRightAndFade data-[side=top]:animate-slideDownAndFade z-20 rounded-md border bg-popover data-[state=open]:transition-all",
          attrs.class ?? ""
        )}
      >
        {slots.default?.()}
      </HoverCardContent>
    );
  },
});

export default {
  Root,
  Trigger,
  Content,
};
